import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT, footerGroups } from '../data/navigation';
import { Wordmark } from './Wordmark';
const linkClass = 'text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta';
export function Footer() {
  return <footer className="w-full bg-navy text-aluminum" data-id="element-40" data-mp="36q90ex3g2ind">
      <div className="mx-auto max-w-shell px-5 py-14 lg:px-10 lg:py-20" data-id="element-41" data-mp="3ufa5cad2jbnw">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)]" data-id="element-42" data-mp="3ud7ghtnnjokr">
          <div data-id="element-43" data-mp="37xwqjq946jl">
            <Wordmark tone="light" variant="footer" data-id="element-44" data-mp="36d44znhyxod" />
            <p className="rp-measure mt-6 text-[14px] leading-relaxed text-aluminum" data-id="element-45" data-mp="3ldap3k9vobm0">
              High-rake CNC lathe holders, inserts, starter kits and application
              guidance for aluminum, copper and titanium.
            </p>
            <dl className="mt-8 space-y-3 text-[14px]" data-id="element-46" data-mp="2a1jl9ej7c453">
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-47" data-mp="2ezbf4e3eq0bx">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-48" data-mp="3l9agxskjxm96">
                  SALES
                </dt>
                <dd data-id="element-49" data-mp="3gbr0cm0dsxe2">
                  <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-line="sales" data-analytics-location="footer" className={`font-mono ${linkClass}`} data-id="element-50" data-mp="3gca5t38uhtb7">
                    {CONTACT.phoneLabel}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-51" data-mp="33nlq3us7fjn">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-52" data-mp="hrs6rehb435l">
                  TECHNICAL ASSISTANCE
                </dt>
                <dd data-id="element-53" data-mp="cvtlhzr9z19e">
                  <a href={CONTACT.techPhoneHref} data-analytics="phone-click" data-analytics-line="technical" data-analytics-location="footer" className={`font-mono ${linkClass}`} data-id="element-54" data-mp="qt8ipqnrsdbx">
                    {CONTACT.techPhoneLabel}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-55" data-mp="13tkanu55dt98">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-56" data-mp="13r7pz98094sh">
                  EMAIL
                </dt>
                <dd data-id="element-57" data-mp="1cm43uf2o75mo">
                  <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="footer" className={linkClass} data-id="element-58" data-mp="1ckkpiu0kr4nj">
                    {CONTACT.email}
                  </a>
                </dd>
              </div>
              <div data-id="element-59" data-mp="1ri3m2ijhum5j">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-60" data-mp="1rgiqcplg0x63">
                  MAILING ADDRESS
                </dt>
                <dd className="mt-1 text-aluminum" data-id="element-61" data-mp="3t9gggdnu5bnc">{CONTACT.mailingAddress}</dd>
              </div>
            </dl>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4" data-id="element-62" data-mp="2ageuzlktm38m">
            {footerGroups.map(group => <nav key={group.label} aria-label={`Footer ${group.label}`} data-id="element-63" data-mp="25mkcumkv5wbn">
                <h2 className="font-mono text-[10px] tracking-label text-copper" data-id="element-64" data-mp="21n1u9xgilxbz">
                  {group.label.toUpperCase()}
                </h2>
                <ul className="mt-4 space-y-2.5" data-id="element-65" data-mp="2tehpuh01uuec">
                  {group.links.map(link => <li key={link.href} data-id="element-66" data-mp="2pbuui6466rce">
                      <Link to={link.href} className="inline-block py-1 text-[13.5px] leading-snug text-aluminum transition-colors duration-150 ease-precise hover:text-white" data-id="element-67" data-mp="2pcw4e79g97sj">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6" data-id="element-68" data-mp="2rvra3mqob2j1">
          <p className="text-[12.5px] text-aluminum/80" data-id="element-69" data-mp="2ru6ahipi4teb">
            © 2026 Robertson Precision, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}